import React, { useState, useEffect, useRef } from 'react';
import { FiPlus, FiEdit, FiTrash2, FiCopy, FiCalendar } from 'react-icons/fi';

const ContextMenu = ({ 
  x, 
  y, 
  onClose, 
  onNewAppointment, 
  onEditAppointment, 
  onDeleteAppointment, 
  onCopyAppointment,
  appointment = null,
  slot = null 
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  const menuItems = appointment ? [
    {
      icon: FiEdit,
      label: 'Edit Appointment',
      action: () => {
        onEditAppointment(appointment);
        onClose();
      }
    },
    {
      icon: FiCopy,
      label: 'Copy Appointment',
      action: () => {
        onCopyAppointment(appointment);
        onClose();
      }
    },
    {
      icon: FiTrash2,
      label: 'Delete Appointment',
      action: () => {
        onDeleteAppointment(appointment);
        onClose();
      },
      className: 'text-red-600 hover:bg-red-50'
    }
  ] : [
    {
      icon: FiPlus,
      label: 'New Appointment',
      action: () => {
        onNewAppointment(slot);
        onClose();
      }
    }
  ];

  return (
    <div
      ref={menuRef}
      className="fixed bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50 min-w-48"
      style={{ 
        left: x, 
        top: y,
        transform: 'translate(-50%, 0)'
      }}
    >
      {menuItems.map((item, index) => (
        <button
          key={index}
          onClick={item.action}
          className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-3 transition-colors ${
            item.className || 'text-gray-700'
          }`}
        >
          <item.icon className="w-4 h-4" />
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default ContextMenu;
